module.exports = __webpack_public_path__ + "static/media/IMG_1463.c3c9a659.JPG";